import { DetailedRadio } from "@amzn/stencil-react-components/radio";
import React, { FC } from "react";
import type { DeviceOption } from "@/services/device-options/device-options.types";

export interface DeviceCardProps {
  option: DeviceOption;
  selected: boolean;
  groupName: string;
  onSelect: () => void;
}

export const DeviceCard: FC<DeviceCardProps> = ({ option, selected, groupName, onSelect }) => (
  <DetailedRadio
    name={groupName}
    value={option.id}
    titleText={`${option.make} ${option.model}`}
    details={option.specsLine}
    checked={selected}
    onChange={onSelect}
    dataTestId={`device-card-${option.id}`}
  />
);
